import React, { useEffect } from 'react'
import styled from 'styled-components'
import { rgba, readableColor } from 'polished'
import { any, bool, func, number, object } from 'prop-types'

const StyledItem = styled.li`
  ${({ active, theme }) => {
    if (!active) return
    return `
      background-color: ${rgba(theme.primary, 0.05)};
      color: ${readableColor(theme.backgroundColor)};
    `
  }}
`

export const UserMenuItem = ({ active, index, node, setActiveIndex, userMenuData }) => {
  const ref = React.createRef()

  useEffect(() => {
    if (!ref.current) return

    if (active) {
      ref.current.focus()
    }
  }, [active])

  const handleMouseMove = () => {
    if (!active) setActiveIndex(index)
  }

  return (
    <StyledItem role='menuitem' active={active} onMouseMove={handleMouseMove}>
      {React.createElement(node, {
        ...userMenuData,
        ref: ref,
      })}
    </StyledItem>
  )
}

UserMenuItem.propTypes = {
  active: bool,
  index: number,
  node: any,
  setActiveIndex: func,
  userMenuData: object,
}
